import React from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";
import Button from "components/common/Button";
import { makeStyles } from "@mui/styles";
import RequestDrawer from "./RequestDrawer";
import { format } from "date-fns";
const useStyles = makeStyles((theme) => ({
  Table_heading: {
    display: "flex",
    justifyContent: "center",
    height: "25px",
  },
}));
const Vehicle = ({
  modelDropdownData,
  data,
  getModalDropdown,
  toggleDrawer,
  vehicledrawerOpen,
  getVarientDropdown,
  getVarientDropdownData,
  response,
  handleSubmit,
  handleApproveRequestVehicle,
  responseManufacturer,
  handleCloseModal,
  handleOnChange,
  handleUpdateRequestVehicle,
  page,
  limit,
  totalCount,
  onPageChange,
  isLoading,
  formData,
  handleVariantInputFieldOpen,
  handleModelInputFieldOpen,
  handleManufacturerInputFieldOpen,
  variantInputFieldOpen,
  modelInputFieldOpen,
  manufacturerInputFieldOpen
}) => {

  const classes = useStyles();

  const columns = [
    {
      field: "customer_name",
      headerName: (
        <>
          <span>Customer Name</span>
        </>
      ),
    },
    {
      field: "mobile",
      headerName: (
        <>
          <span>Mobile Number</span>
        </>
      ),
    },
    {
      field: "date",
      headerName: "Date",
      valueGetter: (v, d) => (     
        <>
        <div style={{width:'100px !important'}}>
        {format(new Date(d.date), "dd MMM yyyy")}
          </div>
        </>
      ),
    },

    {
      field: "type_request",
      headerName: "EV Type ",
    },
    {
      field: "vehicle_registration_no",
      headerName: "Registration No.",
    },

    {
      field: "manufacturer",
      headerName: (
        <>
          <span>Manufacturer</span>
        </>
      ),
    },
    {
      field: "model",
      headerName: "Model",
    },
    {
      field: "variant",
      headerName: "Variant",
    },
    {
      field: "purchageyear",
      headerName: (
        <>
          <span>Purchased Year</span>
        </>
      ),
    },
    {
      field: "uses",
      headerName: (
        <>
          <span>Usage</span>
        </>
      ),
    },
    {
      field: "i am",
      headerName: (
        <>
          <span>I am a</span>
        </>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      valueGetter: (v, d) => {
        const manufacturer = {
          ...d
        };
        return (
          <>
            {
              <div className={classes.Table_heading}>
                <Button
                  style={{ fontSize: "13px" }}
                  variant="contained"
                  onClick={() => toggleDrawer({ manufacturer: manufacturer })}
                >
                  Respond
                </Button>
              </div>
            }
          </>
        );
      },
    },
  ];

  return (
    <>

  <CTable
    columns={columns}
    data={data ?? []}
    isLoading={isLoading}
    pagination={true}
    page={page}
    rowsPerPage={limit}
    count={totalCount }
    onPageChange={onPageChange}
  />


      <RequestDrawer
      getVarientDropdownData={getVarientDropdownData}
      getVarientDropdown={getVarientDropdown}
      modelDropdownData={modelDropdownData}
      formData={formData}
        response={response}
        handleSubmit={handleSubmit}
        dataid={responseManufacturer}
        toggleDrawer={toggleDrawer}
        drawerOpen={vehicledrawerOpen}
        handleApproveRequestVehicle={handleApproveRequestVehicle}
        handleCloseModal={handleCloseModal}
        handleOnChange={handleOnChange}
        handleUpdateRequestVehicle={handleUpdateRequestVehicle}
        handleVariantInputFieldOpen={handleVariantInputFieldOpen}
        handleModelInputFieldOpen={handleModelInputFieldOpen}
        handleManufacturerInputFieldOpen={handleManufacturerInputFieldOpen}
        variantInputFieldOpen={variantInputFieldOpen}
        modelInputFieldOpen={modelInputFieldOpen}
        manufacturerInputFieldOpen={manufacturerInputFieldOpen}
        getModalDropdown={getModalDropdown}
      />
    </>
  );
};

export default withRouter(Vehicle);
